module.exports = __webpack_public_path__ + "static/media/accountant.220e125d.jpg";